import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { InputField } from '../../../model';
import { ContentElement, ContentElementEnum } from '@urbannex/storethemes';
import { ColorPickerPopoverComponent } from '../../dialogs/color-picker-popover/color-picker-popover.component';
import { BorderPresetPopoverComponent } from '../../dialogs/border-preset-popover/border-preset-popover.component';
import { FontSizePopoverComponent } from '../../dialogs/font-size-popover/font-size-popover.component';
import { PaddingPresetPopoverComponent } from '../../dialogs/padding-preset-popover/padding-preset-popover.component';
import { FontWeightPopoverComponent } from '../../dialogs/font-weight-popover/font-weight-popover.component';
import { FontFamilyPopoverComponent } from '../../dialogs/font-family-popover/font-family-popover.component';
import { UnderlinePresetPopoverComponent } from '../../dialogs/underline-preset-popover/underline-preset-popover.component';
import { CellEditorStoreService } from '../../cell-editor-store.service';
import { SectionEditorStoreService } from '../../dialogs/section-editor-dialog/section-editor-store.service';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { SectionBuilderStoreService } from '../../sections-editor/shared-section-builder/section-builder-store.service';
import { CssServicesService } from '../../../services/css-services.service';

@Component({
  selector: 'kve-content-element-field-editor',
  templateUrl: './content-element-field-editor.component.html',
  styleUrls: ['./content-element-field-editor.component.scss']
})
export class ContentElementFieldEditorComponent implements OnChanges{
  @Input() field: InputField;
  text:string;
  contentElementEnum:ContentElementEnum;
  isHeader: boolean = false; 
  background:string;
  classes:string[] = [];

  component: any = ColorPickerPopoverComponent;
  
  borderPop:any = BorderPresetPopoverComponent;
  
  paddingPop:any = PaddingPresetPopoverComponent;
  
  fontSizePop:any = FontSizePopoverComponent;
  fontWeightPop:any = FontWeightPopoverComponent;
  fontFamPop:any = FontFamilyPopoverComponent;
  
  underlinePop:any = UnderlinePresetPopoverComponent;
  color:string;
  colors:string[] = [];
  content:ContentElement;

  constructor(private cellEditorStoreService:CellEditorStoreService,
      private sectionEditorStoreService:SectionEditorStoreService,
      private sectionBuilderStoreService:SectionBuilderStoreService,
      private communicator:IframeCommunicationService,
      private cssServicesService:CssServicesService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['field']) {
      console.log('Content Element Field Editor Changes:', this.field);
      // Additional logic can be added here if needed
      //Check if header
      if(this.field.context != undefined && this.field.context != null){
        this.content = this.field.context;
        console.log(this.content);
        this.isHeader = this.field?.context?.isHeader || false;
        console.log(this.isHeader);
        this.color = this.field?.context?.color;
        if (!this.field?.context?.color) {
          this.cssServicesService.getTextColor().subscribe(color => {
            this.color = color;
          })
        }
      }
      this.colors = this.cssServicesService.getMergredColors();

    }
  }


  setHorizontalAlign(alignment: string) {

  }


}
